export interface ISortingOptions {
  phrase_key: string;
  active: number;
  is_default: number;
}
